module.exports = __webpack_public_path__ + "media/notification-v2.a6bd4d41.wav";